import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";
import { BrandCategoryModel, BrandModel } from "@insite/client-framework/Types/ApiModels";
import CustomHomepageBrandFiltersData from "@tCentro/Store/Reducer/CustomHomepageBrandFilterState";


const initialState: CustomHomepageBrandFiltersData = {
    homepageBrandFiltersData: [],
};

const reducer = {
    "Custom/Brand/setInitialValue": (draft: Draft<CustomHomepageBrandFiltersData>) => {
        draft.homepageBrandFiltersData = [];
    },
    "Custom/Brand/BrandFilterData": (draft: Draft<CustomHomepageBrandFiltersData>, action: { data: BrandModel[] }) => {
        draft.homepageBrandFiltersData = action.data;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
